module.exports = __webpack_public_path__ + "81d8eec884d6158132260e6f851e7c24.png";